import { Select } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './Period.css';
import { TSelect } from '../../../common/types/options';

interface IIPeriodProps {
  monthGroup: JSX.Element;
  yearOptions: TSelect[];
  handleYear: (value: string) => void;
  currentYear: string;
  ratingStatus: boolean;
}

export const Period: React.FC<IIPeriodProps> = ({ monthGroup, yearOptions, handleYear, currentYear, ratingStatus }) => {
  return (
    <fieldset className={style['container']}>
      <div className={style['select-container']}>
        <Select options={yearOptions} onChange={handleYear} value={currentYear} size="M" disabled={ratingStatus} />
      </div>
      {monthGroup}
    </fieldset>
  );
};
